const registeredStyles = {};

export const registerStyles = (styleDefinition) => {
  registeredStyles[styleDefinition.styleCategory] = styleDefinition;
};

export const getStyleByName = (styleName) => {
  return registeredStyles[styleName];
};
